export default "__VITE_ASSET__aa6bb7f0__"